import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import capitalize from 'capitalize';
import _ from 'lodash';
import { compose } from 'recompose';
import { Message, Icon, Card, Grid, Divider, Button } from 'semantic-ui-react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { loadingCampaignsList, setPermissionStatus } from './actions';
import { PARTNER_AGENCY, CLIENT, ACTIVE, ARCHIVED, INFLUENCER } from '../../utils/static-configuration';
import { getCampaignMembers } from '../../utils/jsonapi-functions/campaigns';
import AvatarProfile from '../../components/avatar';
import InfluencerCampaignCard from '../../components/influencer-campaign-card';
import { reportError } from '../../utils/error-handling-service';
import { authService } from '../../utils/auth-service';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

import InfluencerSetupForm from '../../components/influencer-setup-form';

const InfluencerSetupModal = props => (
  <DyzioModal
    hasActionButton
    actionButtonContent="Close"
    headerText="Complete your profile"
    onActionButtonClick={props.onClose}
    {...props}
  >
    <InfluencerSetupForm influencer={props.influencer} />
  </DyzioModal>
);

const ENROLLED_BY = {
  self: 'SELF',
};
class InfluencersCampaignList extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      viewPeople: false,
      campaignPeople: [],
      archiving: {
        modal: false,
        permissionId: null,
        campaignId: null,
      },
      influencer: null,
      influencerSetupModalVisible: false,
      selfEnrolled: false,
    };
  }

  async getCampaignMembers(id) {
    if (!id) return;
    try {
      const returnedData = await getCampaignMembers(id);
      const dataToTree = returnedData.toJSONTree();
      const members = dataToTree.members;
      this.setState({ viewPeople: true, campaignPeople: members });
    } catch (error) {
      reportError('GET_CAMPAIGN_MEMBERS_LIST_ERROR', error.message);
    }
  }

  componentDidMount() {
    // Load the users campaign list
    this.props.onLoadingCampaignsList();
    this.loadInfluencer();
  }

  closeinfluencerSetupModal = () => {
    this.setState({
      influencerSetupModalVisible: false,
    });
  }

  loadInfluencer = () => {
    const profile = authService.getProfile();
    const organisationId = profile.app_metadata.dyzio.o_id;

    const { jsonAPIClient } = this.props;
    jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] })
      .then(organisation => organisation.toJSONTree())
      .then(org => {
        const { influencer } = org;
        console.log(influencer);
        const selfEnrolled = (influencer.enrolledBy === ENROLLED_BY.self);
        const influencerSetupModalVisible = (selfEnrolled && !influencer.setupComplete);
        this.setState({
          influencer,
          influencerSetupModalVisible,
          selfEnrolled,
        });
      })
      .catch(e => {
        console.log(e);
      });
  }


  findClick(id, path, e) {
    // let isClickInsidePeople = this.refs['people-' + id].contains(e.target);
    // if (isClickInsidePeople) {
    //   this.getCampaignMembers(id);
    // }

    const isClickInsidePermissionStatus = this.refs[`permission-status-${id}`].contains(e.target);
    if (!isClickInsidePermissionStatus) {
      this.context.router.push(path);
    }
  }

  toggleViewPeople = () => {
    this.setState({ viewPeople: !this.state.viewPeople });
  };

  redirectToCampaignPage = id => {
    // INFLUENCERS MUST NOT USE THE NEW CAMPAIGN ROUTE!!!
    this.context.router.push(`/acr-campaign/${id}?collaborations`);
  }

  onOutsideClick(event) {
    const isClickInside = this.refs.modal_content.contains(event.target);
    if (this.state.viewPeople && !isClickInside) {
      this.setState({ viewPeople: false });
    }
  }

  setPermissionStatus = (campaignPermissionId, campaignId, status) => () => {
    this.props.onSetPermissionStatus(campaignPermissionId, campaignId, status);
    this.setState({ archiving: { modal: false } });
  };

  render() {
    const {
      campaignsList,
      campaignsLoadError,
      campaignsLoading,
      showCampaignsList,
      userData,
    } = this.props;

    const { influencerSetupModalVisible, influencer, selfEnrolled } = this.state;

    const profile = authService.getProfile();
    const userRole = profile.app_metadata.dyzio.role;
    const userIsInfluencer = userRole === INFLUENCER;

    const getFriendlyRole = role => capitalize.words(role.replace('_', ' ').toLowerCase());
    const filteredCampaignList = campaignsList.filter(campaignPermission => campaignPermission.get('status') === showCampaignsList);

    console.log(filteredCampaignList.toJSON());

    const isVoxogram = window.location.hostname === 'app.voxogram.com';
    const displayName = isVoxogram ? 'voxogram' : 'dyzio';


    return (
      <div className="grid" onClick={campaignsLoading ? '' : this.onOutsideClick.bind(this)} >
        { showCampaignsList === ARCHIVED &&
          <p className="small light info">
            Archived campaigns are hidden for you but are still available to others.
          </p>
        }
        { campaignsLoadError &&
          <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
            <div className="hero left">
              <h3>There was a problem loading your campaigns. {campaignsLoadError}</h3>
              <br />
              <p>Please check you are connected to the internet and try again.</p>
            </div>
          </div>
        }
        {
          influencerSetupModalVisible &&
          <InfluencerSetupModal influencer={influencer} onClose={this.closeinfluencerSetupModal} />
        }
        {
          userIsInfluencer &&
          <div style={{ padding: '0px 15px' }}>

            <Grid columns={2} divided>
              <Grid.Row>
                <Grid.Column width={10}>
                  <Card color="pink" fluid>
                    <Card.Content header={`Welcome to ${displayName} - so what does it do?`} />
                    <Card.Content>
                      <p>
                        {displayName} allows agencies and brands to easily create influencer marketing campaign reports. By authorising {displayName} to read data from your social channels, your client can then see live data for your campaign posts, without constantly bothering you for screenshots or data requests.
                      </p>
                      <br />

                      <p>
                      Once your channels are authenticated (read-only access),  allows your client to see the data related to your posts and no one else.
                      </p>
                      <br />
                      <p>
                        {displayName} is <strong>FREE</strong> for influencers to authenticate, plus there are some great free features arriving soon, to help you manage your business and brand activities.
                      </p>
                      <br />
                    </Card.Content>
                    {
                      !isVoxogram &&
                      <Card.Content extra>
                        <Icon name="help circle outline" />
                        <a
                          href="https://help.dyzio.co/dyzio-contextual-help/welcome-to-dyzio"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          find out more about {displayName}...</a>
                      </Card.Content>
                    }
                  </Card>

                </Grid.Column>
                <Grid.Column width={6}>

                  <Button
                    inverted
                    color="pink"
                    fluid
                    size="massive"
                    icon
                    labelPosition="left"
                    onClick={() => this.context.router.push('/influencer/authorisation')}
                  >
                    <Icon name="unlock alternate" />
                    Click here to Authorise
                  </Button>

                  { selfEnrolled &&
                    <div>
                      <br />
                      <br />

                      <Button
                        inverted
                        color="blue"
                        fluid
                        icon
                        labelPosition="left"
                        onClick={() => this.setState({ influencerSetupModalVisible: true })}
                      >
                        <Icon name="wpforms" />
                      show profile setup form
                      </Button>
                    </div>
                  }

                  {
                    !isVoxogram &&
                    <Message info>
                      <Icon name="help circle outline" />
                      <a
                        href="https://help.dyzio.co/influencer-experience/authorising-dyzio"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                      Need help authorising {displayName}?</a>
                    </Message>
                  }

                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Divider />
            <h2>Campaigns</h2>
          </div>
        }
        <Divider hidden />
        <Card.Group itemsPerRow={3} style={{ margin: '0px 15px' }}>
          {
            _.map(filteredCampaignList.toArray(),
              campaignPermission => (
                <InfluencerCampaignCard
                  {...campaignPermission.toJSON()}
                  onClick={this.redirectToCampaignPage}
                />
              ),
            )
          }
        </Card.Group>

        { campaignsLoading &&
          <div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6">
              <div className="box loading" />
            </div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6">
              <div className="box loading" />
            </div>
            <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6">
              <div className="box loading" />
            </div>
          </div>
        }
        <div className={this.state.viewPeople ? 'custom-modal visible' : 'custom-modal'}>
          <div className="modal-content" ref="modal_content">
            <div className="top">
              <h3>People on this campaign</h3>
            </div>
            <div className="modal-close">
              <img src="/icons/close.svg" alt="close" onClick={this.toggleViewPeople} />
            </div>
            <div className="center">
              <div className="members-list">
                <table>
                  { this.state.campaignPeople.length !== 0 &&
                    <tbody>
                      { this.state.campaignPeople.map(person => {
                        const personName = person.name;
                        const personId = person.id;
                        const role = person.role;
                        const email = person.email;
                        return (
                          <tr key={personId}>
                            <td className="avatar">
                              <AvatarProfile name={personName} role={role} email={email} pending={false} size={44} noTooltip />
                            </td>
                            <td>
                              <p>{personName}</p>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  }
                </table>
              </div>
            </div>
            <div className="spacer small" />
            <button className="medium rose stretch" onClick={this.toggleViewPeople}>Done</button>
          </div>
        </div>
        <div className={this.state.archiving.modal ? 'custom-modal visible' : 'custom-modal'}>
          <div className="modal-content">
            <div className="top">
              <h3>Archive this campaign</h3>
            </div>
            <div className="modal-close">
              <img src="/icons/close.svg" alt="close" onClick={() => this.setState({ archiving: { modal: false } })} />
            </div>
            <div className="center">
              <p>
                By archiving this campaign it will no longer be one of your active campaigns. However, other people on this campaign can still choose to see it.
              </p>
              <div className="spacer" />
              <div className="spacer" />
              <button className="large rose stretch" onClick={this.setPermissionStatus(this.state.archiving.permissionId, this.state.archiving.campaignId, ARCHIVED)}>
                <p>Archive campaign</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userData: state.userData.get('userData'),
  campaignsList: state.campaignList.get('campaigns'),
  showCampaignsList: state.campaignList.get('showCampaignsList'),
  archivedCampaignsList: state.campaignList.get('archivedCampaigns'),
  campaignsLoadError: state.campaignList.get('campaignsLoadError'),
  campaignsLoading: state.campaignList.get('campaignsLoading'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadingCampaignsList: statusFilter => dispatch(loadingCampaignsList(statusFilter)),
    onSetPermissionStatus: (campaignPermissionId, campaignId, status) => dispatch(setPermissionStatus(campaignPermissionId, campaignId, status)),
  };
}

export default compose(hasJSONAPIClient)(connect(mapStateToProps, mapDispatchToProps)(InfluencersCampaignList));



/** WEBPACK FOOTER **
 ** ./src/containers/influencers-campaign-list/index.js
 **/